export class Footer {
  footerNav = document.getElementById("footer-nav");
  auroraCanvasContainer = document.getElementById("aurora-canvas-container");
  auroraClipStartOffset = 0;
  maxPageScroll = 0;

  clipBottomOffset = 0;
  clipBlockOffset = 0;
  clipRadius = 0;

  isMobileView = window.innerWidth <= 880;
  isMobileViewClipActive = false;

  constructor() {
    this.init();
  }

  init = () => {
    if (!this.footerNav || !this.auroraCanvasContainer) {
      return;
    }

    this.setClipParams();
    window.addEventListener("scroll", () => this.setAuroraClip());
    window.addEventListener("resize", this.onWindowResize);

    this.auroraCanvasContainer.classList.toggle(
      "aurora-canvas-container--mobile",
      this.isMobileView,
    );
  };

  onWindowResize = () => {
    this.isMobileView = window.innerWidth <= 880;

    this.auroraCanvasContainer?.classList.toggle(
      "aurora-canvas-container--mobile",
      this.isMobileView,
    );

    this.setClipParams(true);
  };

  setClipParams = (forceUpdate = false) => {
    if (!this.footerNav) {
      return;
    }

    this.auroraClipStartOffset =
      window.scrollY +
      this.footerNav.getBoundingClientRect().top -
      window.innerHeight -
      44;

    this.maxPageScroll = document.body.scrollHeight - window.innerHeight;

    this.setAuroraClip(forceUpdate);
  };

  setAuroraClip = (forceUpdate = false) => {
    if (!this.footerNav || !this.auroraCanvasContainer) {
      return;
    }

    if (this.isMobileView) {
      const isMobileViewClipActive =
        window.scrollY > this.auroraClipStartOffset + 40;

      if (
        isMobileViewClipActive === this.isMobileViewClipActive &&
        !forceUpdate
      ) {
        return;
      }

      this.isMobileViewClipActive = isMobileViewClipActive;

      this.auroraCanvasContainer.classList.toggle(
        "aurora-canvas-container--mobile-active",
        isMobileViewClipActive,
      );

      let clipBottomOffset = isMobileViewClipActive
        ? this.maxPageScroll - this.auroraClipStartOffset + 10
        : 0;

      this.auroraCanvasContainer.style.setProperty(
        "--aurora-clip-offset-bottom",
        `${clipBottomOffset}px`,
      );

      const clipBlockOffset = isMobileViewClipActive ? 10 : 0;

      this.auroraCanvasContainer.style.setProperty(
        "--aurora-clip-offset-block",
        `${clipBlockOffset}px`,
      );

      const clipRadius = isMobileViewClipActive ? 25 : 0;

      this.auroraCanvasContainer.style.setProperty(
        "--aurora-clip-radius",
        `${clipRadius}px`,
      );

      return;
    }

    const clipBottomOffset = Math.max(
      0,
      window.scrollY - this.auroraClipStartOffset,
    );

    if (clipBottomOffset !== this.clipBottomOffset) {
      this.clipBottomOffset = clipBottomOffset;

      this.auroraCanvasContainer.style.setProperty(
        "--aurora-clip-offset-bottom",
        `${clipBottomOffset}px`,
      );
    }

    const clipBlockOffset = Math.min(20, (clipBottomOffset / 100) * 20);

    if (clipBlockOffset !== this.clipBlockOffset) {
      this.clipBlockOffset = clipBlockOffset;

      this.auroraCanvasContainer.style.setProperty(
        "--aurora-clip-offset-block",
        `${clipBlockOffset}px`,
      );
    }

    const clipRadius = Math.min(25, (clipBottomOffset / 100) * 25);

    if (clipRadius !== this.clipRadius) {
      this.clipRadius = clipRadius;

      this.auroraCanvasContainer.style.setProperty(
        "--aurora-clip-radius",
        `${clipRadius}px`,
      );
    }
  };
}
